<template>
    <a
        :class="[
            {active: config.value === sortBy},
            {'is-reverse': isReverse},
            `control-${config.value}`,
        ]"
        href="#"
        @click.prevent="emitValue(config.value, config.iteratees)"
    >
        {{ config.listLabel }}
    </a>
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            required: true,
        },
        sortBy: {
            type: String,
            default: '',
        },
        isReverse: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        /**
         * Handle sort change
         *
         * @param   {string}  value      Sort value
         * @param   {Function[]|string}   iteratees  Iteratees to sort by
         *
         */
        emitValue(value, iteratees) {
            if (value === this.sortBy) {
                this.$emit('change', {
                    isReverse: ! this.isReverse,
                    iteratees,
                });
            } else {
                this.$emit('change', {
                    isReverse: false,
                    sortBy: value,
                    iteratees,
                });
            }
        },
    },
};
</script>
